import React from "react";
import Modal from 'react-modal';
import '../Styles/Login.css';
 import GoogleLogin from 'react-google-login';
 
const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
  },
};
class Head extends React.Component {

  constructor() {
    super();
    this.state = {
      backgroundColor: '',
      loginModalIsOpen: false,
      createaccountModalIsopen:false
      
    };
  }

  componentDidMount() {
    const path = this.props.history.location.pathname;
    this.setAttributes(path);
  }

  handleLogin = () => {
    this.setState({ loginModalIsOpen: true });
  };
  handleCancel=()=>{
    this.setState({ loginModalIsOpen: false });
  }
  handleCreateAccount=()=>{
    this.setState({ createaccountModalIsopen: true });
  }
  handleCancelAccount=()=>{
    this.setState({createaccountModalIsopen : false });
  }
  
  setAttributes = (path) => {
    let bg, display;
    if (path === '/') {
      bg = 'black';
      display = 'none';
    } else {
      bg = 'red';
      display = 'inline-block';
    }
    this.setState({ backgroundColor: bg, display: display });
  };

  render() {
    const { backgroundColor, loginModalIsOpen, loggedUser, isloggedIn , createaccountModalIsopen} = this.state;

    return (
     
      <div>
        <nav className="navbar" style={{ backgroundColor: backgroundColor }}>
          <div className="container-fluid d-flex justify-content-end">
            <form className="d-flex">
            {!isloggedIn ? (
              <>
              <div className="btn-group me-2" role="group" aria-label="Basic example">
                <button className="btn btn-light" type="button" onClick={this.handleLogin}>Login</button>
              </div>
              <div className="btn-group" role="group" aria-label="Basic example">
                <button className="btn btn-outline-light mx-3" type="button" onClick={this.handleCreateAccount} >Create an account</button>
              </div>
              </>
             ) : (
              <>
              <div className="btn-group me-2" role="group" aria-label="Basic example">
                <button className="btn btn-light" type="button">{loggedUser}</button>
              </div>
              <div className="btn-group" role="group" aria-label="Basic example">
                <button className="btn btn-outline-light mx-3" type="button">Logout</button>
              </div>
              </> )}
            </form>
          </div>
        </nav>
        <Modal
          isOpen={loginModalIsOpen}
          style={customStyles}
          >
           <div>
          <GoogleLogin
    clientId="957651683796-ktrno6grovu40scij3apeku6ecr6sl83.apps.googleusercontent.com"
    buttonText="Continue  with Google"
    onSuccess={this.responseGoogle}
    onFailure={this.responseGoogle}
    cookiePolicy={'single_host_origin'}
  />
          </div>
          <h2>Login Form</h2>
          <div className="container">
            <label htmlFor="uname"><b>Username</b></label>
            <br/>
            <input type="text" placeholder="Enter Username" name="uname" required  className="Input1"/>
            <br/>
           <label htmlFor="psw"><b>Password</b></label>
           <br/>
            <input type="password" placeholder="Enter Password" name="psw" required className="Input1" />
            <button type="submit"  className="button1" onclick={this.handleLogin}>Login</button>
          </div>

          <div className="container" style={{ backgroundColor: '#f1f1f1' }}>
            <button className="cancelbtn" onClick={this.handleCancel}>Cancel</button>
            <span className="psw">Forgot <a href="/">password?</a></span>
          </div>
        </Modal>
        <Modal
          isOpen={createaccountModalIsopen}
        
          >
<div class="container">
				<div class="row d-flex justify-content-center align-items-center h-100">
				<div class="col-lg-12 col-xl-11">
        <h2 style={{textAlign:"center",marginLeft:"50px"}} >Sign Up</h2>
				  <div class="card text-black" style={{borderRadius: "25px;"}}>
					<div class="card-body p-md-5">
					  <div class="row justify-content-center">
						<div class="col-md-10 col-lg-6 col-xl-5 order-2 order-lg-1">
		 <form >
							<div class="form-group">
								<label for="name"><h3>Name</h3></label>
								<input type="text" class="form-control" name="name" placeholder="Enter your Name" required/>
							  </div>
							<div class="form-group">
							  <label for="email"><h3>Email address</h3></label>
							  <input type="email" class="form-control" name="email" aria-describedby="emailHelp" placeholder="Enter email" required/>
							  <small id="emailHelp" class="form-text text-muted">We'll never share your email with anyone else.</small>
							</div>
              <div>
                    <i class="fas fa-lock fa-lg me-3 fa-fw"></i>
                    <div data-mdb-input-init class="form-outline flex-fill">
                    <label class="form-label" for="form3Example4c"><h3>Password</h3></label>
                      <input type="password" id="form3Example4c" class="form-control" required />
                    
                    </div>
                  </div>
							<div >
                    <input class="form-check-input me-2" type="checkbox" value="" id="form2Example3c" />
                    <label class="form-check-label" for="form2Example3">
                      I agree all statements in <a href="#!">Terms of service</a>
                    </label>
                  </div>
                  <button type="submit" style={{backgroundColor:"blue",color:"white",marginTop:"20px"}}>Register</button>
                  <div style={{marginright:"10px",display:"inline-block"}}>
               
          <GoogleLogin
    clientId="957651683796-ktrno6grovu40scij3apeku6ecr6sl83.apps.googleusercontent.com"
    buttonText="Continue  with Google"
    onSuccess={this.responseGoogle}
    onFailure={this.responseGoogle}
    cookiePolicy={'single_host_origin'}
  />
          </div>
          
						</form> 
            <div className="container" >
            <button className="cancelbtn" onClick={this.handleCancelAccount}>Cancel</button>
            
          </div>
        		</div>
						<div class="col-md-10 col-lg-6 col-xl-7 d-flex align-items-center order-1 order-lg-2">
		  
						  <img src="https://mdbcdn.b-cdn.net/img/Photos/new-templates/bootstrap-registration/draw1.webp"
							class="img-fluid" alt="Sample "/>
		  
						</div>
					  </div>
					</div>
				  </div>
				</div>
			  </div>
			</div>
	</Modal>
   </div>
        );
  }
}

export default Head;
